module.exports = __webpack_public_path__ + "static/img/qcjg3.4142a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcjg3.png
// module id = RF9s
// module chunks = 1